import { axios, Response } from '../index'

export interface GetResumedAccessProfilesResponse {
  id: number
  name: string
  personaType:
    | 'THERAPIST'
    | 'PATIENT'
    | 'PATIENT_RESPONSIBLE'
    | 'ADMIN'
    | 'CLINIC'
    | 'RESPONSIBLE'
  permissions: string[]
}

const getResumedAccessProfiles = (): Response<
  GetResumedAccessProfilesResponse[]
> => {
  return axios.get(`/v1/users/access-profile/ADMIN`)
}

export default getResumedAccessProfiles
